import React from 'react';

import { Typography } from '@occc/ui-design-system';

export const RequiresVoucherForDiscount: React.FC = () => {
  return (
    <>
      <Typography variant='body2'>Requires Voucher For Discount</Typography>
      <Typography>Yes</Typography>
    </>
  );
};
